import { ViewModelFieldName } from "../../Engine/src/Engine/Core/CoreTypes";
import { reject } from "../TypingUtils";

import {
    AbsoluteModelPath,
    AbsoluteResolvedModelPath,
    createAbsolute,
    createAbsoluteFromMask,
    PathToken,
} from "./ModelPath";
import { BaseModelFieldPath } from "./BaseModelFieldPath";

export type ViewModelFieldNameWithCustomFields = ViewModelFieldName | "$errorCount" | "$warningCount" | "";

export class AbsoluteModelFieldPath extends BaseModelFieldPath<AbsoluteModelPath> {
    public constructor(path: AbsoluteModelPath, fieldName: ViewModelFieldNameWithCustomFields) {
        super(path, fieldName);
    }

    public static createFromString(
        pathWithFieldName: string,
        defaultFieldName?: ViewModelFieldNameWithCustomFields
    ): AbsoluteModelFieldPath {
        return this.createFrom(pathWithFieldName, path => createAbsolute(path), defaultFieldName);
    }

    public static createFromMask(
        pathWithFieldName: string,
        multiplicitySymbol: PathToken,
        defaultFieldName?: ViewModelFieldNameWithCustomFields
    ): AbsoluteModelFieldPath {
        return this.createFrom(
            pathWithFieldName,
            path => createAbsoluteFromMask(path, multiplicitySymbol),
            defaultFieldName
        );
    }

    private static createFrom<TModelPath extends AbsoluteModelPath | AbsoluteResolvedModelPath>(
        pathWithFieldName: string,
        modelPathFactory: (path: string) => TModelPath,
        defaultFieldName: ViewModelFieldNameWithCustomFields = "value"
    ): AbsoluteModelFieldPath {
        const match = AbsoluteModelFieldPath.fieldExtractRegex.exec(pathWithFieldName);
        const path = match != undefined ? (match[1] ?? reject()) : pathWithFieldName;
        const field =
            match != undefined ? ((match[2] as ViewModelFieldName | undefined) ?? reject()) : defaultFieldName;

        return new AbsoluteModelFieldPath(modelPathFactory(path), field);
    }
}
